"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readJson = void 0;
exports.safeParse = safeParse;
exports.safeParseBool = safeParseBool;
var fs_1 = __importDefault(require("fs"));
function safeParse(maybeJsonString) {
    var result;
    try {
        result = JSON.parse(maybeJsonString);
    }
    catch (e) {
        console.error("Error parsing JSON " + maybeJsonString + ": ", e);
        result = {};
    }
    return result;
}
function safeParseBool(maybeJsonString) {
    var result;
    try {
        result = JSON.parse(maybeJsonString);
    }
    catch (e) {
        console.error("Error parsing JSON: ", e);
    }
    return result;
}
var readJson = function (path, cb) {
    fs_1.default.readFile(require.resolve(path), function (err, data) {
        if (err)
            cb(err);
        else
            cb(null, JSON.parse(data.toString()));
    });
};
exports.readJson = readJson;
